module.exports = __webpack_public_path__ + "img/logo.7b1c6439.webp";